import React from 'react';

const Videos = () => {
  return (
    <section
      id="videos"
      className="pt-16 px-8 lg:px-32 text-white"
      style={{ backgroundColor: '#1a1a1a' }}
    >
      <div className="container mx-auto">
        <h2 className="text-3xl font-medium text-center mb-8 sm:text-2xl md:text-3xl" style={{ fontFamily: "'EB Garamond', serif" }}>
          VIDEOS
        </h2>

        {/* Wistia Videos in a 3-Column Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Video 1 */}
          <div className="bg-black aspect-[16/10] flex flex-col items-center justify-center rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://fast.wistia.net/embed/iframe/bama6xmms7"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full"
              title="Recording with the LMO for ITV's Endeavour Series 9"
              aria-label="Video: Recording with the LMO for ITV's Endeavour Series 9, 2023"
            ></iframe>
            <div className="flex items-center justify-center h-12">
              <p className="text-center text-xs md:text-sm lg:text-base" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Recording with the LMO for ITV's Endeavour Series 9, 2023
              </p>
            </div>
          </div>

          {/* Video 2 */}
          <div className="bg-black aspect-[16/10] flex flex-col items-center justify-center rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://fast.wistia.net/embed/iframe/jb4zivzxk8"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full"
              title="Recording Gnossieme by Erik Satie at Abbey Road Studios"
              aria-label="Video: Recording Gnossieme by Erik Satie at Abbey Road Studios"
            ></iframe>
            <div className="flex items-center justify-center h-12">
              <p className="text-center text-xs md:text-sm lg:text-base" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Recording Gnossieme by Erik Satie at Abbey Road Studios
              </p>
            </div>
          </div>

          {/* Video 3 */}
          <div className="bg-black aspect-[16/10] flex flex-col items-center justify-center rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://fast.wistia.net/embed/iframe/bm9rk2ygwp"
              allow="autoplay; fullscreen; picture-in-picture"
              className="w-full h-full"
              title="Bach - Allemande from French Suite No. 4"
              aria-label="Video: Bach - Allemande from French Suite No. 4"
            ></iframe>
            <div className="flex items-center justify-center h-12">
              <p className="text-center text-xs md:text-sm lg:text-base" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Bach - Allemande from French Suite No. 4
              </p>
            </div>
          </div>
        </div>

        {/* View All Videos Button */}
        <div className="flex justify-center mt-8">
          <a
            href="https://www.youtube.com/@Sallyheath"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              className="text-white py-1 px-3 rounded-md hover:bg-gray-500 transition duration-300"
              style={{
                fontFamily: "'EB Garamond', serif",
                backgroundColor: '#4a4a4a',
                fontSize: '0.875rem',
              }}
            >
              View All Videos
            </button>
          </a>
        </div>

      </div>
    </section>
  );
};

export default Videos;
